import React, { ReactNode } from 'react';
import { Header } from './Header';
import { Sidebar } from './Sidebar';
import { Footer } from './Footer';
import { SkipLinks } from './SkipLinks';
import { useSidebar } from '../hooks/useSidebar';

interface AppWrapperProps {
  children: ReactNode;
}

export function AppWrapper({ children }: AppWrapperProps) {
  const { isOpen, isMobile, isCollapsed, toggleSidebar, closeSidebar } = useSidebar();

  // Build wrapper class based on sidebar state
  const wrapperClasses = ['app-wrapper'];
  if (isOpen) wrapperClasses.push('sidebar-open');
  if (isCollapsed && !isMobile) wrapperClasses.push('sidebar-collapse');

  return (
    <>
      <SkipLinks />
      <div className={wrapperClasses.join(' ')}>
        <Header onMenuToggle={toggleSidebar} />
        <Sidebar isOpen={isOpen} onClose={closeSidebar} />
        {isMobile && (
          <div
            className={`sidebar-overlay ${isOpen ? 'show' : ''}`}
            onClick={closeSidebar}
            aria-hidden="true"
          />
        )}
        <main id="main-content" className="app-main page-fade-in" role="main">
          {children}
        </main>
        <Footer />
      </div>
    </>
  );
}
